<app-modal-base [title]="dialogTitle" [hasSubmit]="false" cancelType="CLOSE">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content class="text-center">
    <p>Pour une utilisation plus facile et des fonctionnalités plus riches...</p>
    <a [href]="link" appTooltip="Télécharger l'application EEMO"
      ><img [src]="linkAsset" alt="Télécharger l'application EEMO"
    /></a>
    <div class="text-end">
      <mat-checkbox (change)="toggleDontShow($event)">Ne plus afficher</mat-checkbox>
    </div>
  </div>
</ng-template>
